import React from 'react';
import cn from 'bem-cn';

import './MyProfileRating.scss';
// import { Stack } from '../../../components/UI';

const b = cn('my-profile-rating');

export const MyProfileRating: React.FC = () => {
    return (
        <div className={b()}>
            {/* <Stack direction="row" justifyContent="space-between" align-items="center" className={b('header')}>
                <h2>Топ пользователей</h2>
                <span>Что такое ИИ рейтинг?</span>
            </Stack> */}
        </div>
    );
};
